<template>
  <workarea-new-comp />
</template>

<script>
import workareaNewComp from '@/components/home/workareaNewComp.vue'

export default {
  name: 'workArea',

  components: {
    workareaNewComp
  }
}
</script>

<style scoped>

</style>
